/**
 * Les pages que la barre de copie montre en vignettes, quand toutes n'y tiennent pas.
 *
 * Au-delà de ce qui tient, la dernière vignette dit « +N » : une page cachée derrière ne se voit
 * pas. Une page qui n'est pas partie doit, elle, toujours se voir, puisque c'est en la touchant que
 * l'élève la renvoie (Wajih, 18/10, « les pages en échec d'abord »). Les pages en échec passent donc
 * devant, les autres suivent dans l'ordre de la copie. Quand tout tient, l'ordre de la copie reste :
 * rien n'est caché, rien ne bouge.
 *
 * Chaque vignette garde l'index de sa page dans la copie : c'est lui qui l'ouvre en grand et qui la
 * nomme (« Page 4 non envoyée, réessayer »).
 */
import { type UICopyPhoto } from "../../../ports/primary/ui/types/studentActivity"

export type CopyBarThumb = { photo: UICopyPhoto; index: number }

export function copyBarThumbs(photos: UICopyPhoto[], max: number): CopyBarThumb[] {
    const indexed = photos.map((photo, index) => ({ photo, index }))
    if (indexed.length <= max) return indexed
    const failed = indexed.filter((thumb) => thumb.photo.status === "failed")
    const others = indexed.filter((thumb) => thumb.photo.status !== "failed")
    return [...failed, ...others].slice(0, Math.max(0, max))
}
